<!--
 * @Author: ken yang
 * @Date: 2023-04-06 09:33:01
 * @LastEditTime: 2023-08-14 18:02:17
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/components/table/BasicTable.vue
-->
<template>
  <el-table
    ref="table"
    class="BasicTable"
    :data="data"
    :cell-class-name="cellClass"
    :header-row-class-name="headerClass"
    :row-class-name="rowClassName"
    @sort-change="sortChange"
    @row-click="rowClick"
  >
    <el-table-column v-if="isSerial" type="index" width="50" />
    <el-table-column
      v-for="(item) in config"
      :key="item.prop"
      :label="item.label"
      :prop="item.prop"
      :sortable="item.sortable??false"
      :min-width="item.minWidth"
      :width="item.width"
      :align="item.align??'left'"
      :class-name="item.rowClass"
    >

      <template #header="{ column, $index }">
        <slot v-if="Object.keys(slots).includes(item.prop+'Header')" :name="item.prop+'Header'" v-bind="{column,$index,table}" />
        <template v-else>{{ item.label }}</template>
      </template>

      <template #default="{ row,$index }">
        <!-- 插槽 -->
        <slot v-if="Object.keys(slots).includes(item.prop)" :name="item.prop" v-bind="{row,$index,table} || {}" />

        <!-- 时间 -->
        <span v-else-if="item.type==='time'">{{ row[item.prop] ? dayjs(handleTimestamp(row[item.prop])).format('YYYY-MM-DD HH:mm:ss') : '--' }}</span>

        <!-- switch -->
        <Row v-else-if="item.type==='switch'">
          <el-switch
            v-model="row[item.prop]"
            :active-value="item.activeValue"
            :inactive-value="item.inactiveValue"
            :active-text="item.activeText"
            :inactive-text="item.inactiveText"
            :before-change="()=>item.beforeChange(row)"
          />
        </Row>

        <!-- Num 逗号 -->
        <Num v-else-if="item.type==='Num'" :key="item.prop+'Num'">{{ row[item.prop] ?? '--' }}</Num>

        <!-- 字典选择 -->
        <span v-else-if="!isEmpty(item.options)">
          {{ (item?.options?.find((obj)=>obj.value===row[item.prop]))?.label ?? '--' }}
        </span>

        <!-- 直接赋值 -->
        <span v-else-if="!isEmpty(item.value)">{{ item.value(row) }}</span>

        <!-- 图片 -->
        <span v-else-if="item.type==='img'">
          <img v-viewer class="w-60 h-60" :src="row[item.prop]">
        </span>

        <!-- 普通文本 -->
        <span v-else>{{ !isEmpty(row[item.prop]) ? row[item.prop] : '--' }}</span>
      </template>

    </el-table-column>
    <el-table-column
      v-if="Object.keys(slots).includes('action')"
      :label="$t('table.operation')"
      fixed="right"
      align="right"
      :width="actionWidth"
    >
      <template #default="{ row,$index }">
        <slot name="action" :row="row" v-bind="{row,$index,table}" />
      </template>
    </el-table-column>

    <el-table-column
      v-if="Object.keys(slots).includes('expand')"
      v-slot="{ row,$index }"
      type="expand"
      class-name="o-hidden"
      :width="expandWdith"
    >
      <slot name="expand" v-bind="{ row, $index ,table }" />
    </el-table-column>

    <template #empty>
      <ListEmpty />
    </template>
  </el-table>
</template>
<script setup>
import Sortable from 'sortablejs'
const emit = defineEmits()

const table = $ref(null)
let expandWdith = $ref(null)
nextTick(() => {
  expandWdith = 0
})

const slots = useSlots()
const props = defineProps({
  config: {},
  data: {},
  isDraggable: {},
  onStart: {},
  onEnd: {},
  cellClass: {},
  headerClass: {},
  isSerial: {
    default: false
  },
  rowClassName: {},
  actionWidth: {
    default: 80,
  },
})

const _this = $ref({})

const init = () => {
  const el = document.querySelector('.el-table__body-wrapper tbody')

  // 2. 创建并配置相关参数
  var sortable = new Sortable(el, {

    animation: 150,
    onStart (/** Event*/evt) {
      emit('onStart', evt)
    },
    onEnd (evt) {
      emit('onEnd', evt)
    }

  })
}

const sortChange = ({ column, prop, order }) => {
  emit('onSort', { column, prop, order })
}

const rowClick = (row, cloumn) => {
  emit('row-click', row, cloumn)
}

onMounted(() => {
  if (props.isDraggable) {
    init()
  }
})
</script>

<style lang="scss">
.BasicTable{
  .cell{
    font-size: 12px;
  }
  .el-table__inner-wrapper::before{
    display: none !important;
  }
}

</style>
